<div class="ibox-content">
    <form [formGroup]="form">
      <div class="form-group row">
        <mat-error *ngIf="MensajeError" class="eliminacionInvalida">{{MensajeError}}</mat-error>
        <mat-error *ngIf="MensajeRetro && !MensajeError && formHabilitado" class="eliminacionInvalida">{{MensajeRetro}}</mat-error>
      </div>
      <div class="row" hidden="true">
        <input formControlName="id" name="id" type="text" class="form-control" />
        <input formControlName="personal" name="personal" type="text" class="form-control" />
      </div>
      <div class="row panel panel-warning" *ngIf="!disabledEditing">
        <div class="col-lg">
          <label class="col-lg-3 col-form-label font-bold" for="desde">Desde</label>
          <div class="col-lg-8">
            <p-calendar appendTo="body" selectOtherMonths="true" formControlName="desde" dateFormat="dd/mm/yy" inputId="desde" ngDefaultControl (ngModelChange)="onChangeFechas()"></p-calendar>
            <div *ngIf="registerFormControl.desde.errors?.required && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched)" class="text-danger">La Fecha es Requerida</div>
            <mat-error *ngIf="desdeAnterior && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
              No puede ser anterior al ingreso {{ingreso.desde | date:'dd/MM/yyyy'}}
            </mat-error>
            <mat-error *ngIf="anteriorRetroactividad && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
              No puede ser anterior al límite de retroactividad {{grupoLiq.periodoRetroactividadNavigation.fechaDd | date:'dd/MM/yyyy'}}
            </mat-error>
          </div>
        </div>
        <div class="col-lg">
          <label class="col-lg-3 col-form-label font-bold" for="hasta">Hasta</label>
          <div class="col-lg-8">
            <p-calendar appendTo="body" selectOtherMonths="true" formControlName="hasta" dateFormat="dd/mm/yy" inputId="hasta" ngDefaultControl (ngModelChange)="onChangeFechas()"></p-calendar>
            <div *ngIf="registerFormControl.hasta.errors?.required && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched)" class="text-danger">La Fecha es Requerida</div>
            <mat-error  class="text-danger" *ngIf="registerFormControl.hasta.errors?.fecHastaMenor && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched)">
                La Fecha no puede ser menor que la Fecha Desde
            </mat-error>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label class="col-form-label font-bold">Código Nómina</label>
          <div>
            <comboTools [list]=codigosNominaList
                        selected='codigoNomina'
                        [formParent]="form"
                        [isEditing]=disabledEditing
                        filter="descripcion"
                        ph='Código Nómina'
                        (SelectedChange)="onChangeCodigoNomina($event)"
                        ></comboTools>
            <div *ngIf="registerFormControl.codigoNomina.invalid && (
                 registerFormControl.codigoNomina?.dirty || registerFormControl.codigoNomina?.touched || submitted)" class="text-danger">
              Código Nómina es Requerido
            </div>
          </div>
        </div> 
        <div class="col-md-6">
          <div class="form-group">
            <label class=" col-form-label font-bold">Persona Jurídica</label>
            <input formControlName="personaJuridica" maxlength="100" name ="selectedPersonaJuridica" type="text" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.personaJuridica.errors && (registerFormControl.personaJuridica?.dirty || registerFormControl.personaJuridica?.touched || submitted)}"/>
            <mat-error  class="text-danger"*ngIf="registerFormControl.personaJuridica.errors?.required && (registerFormControl.personaJuridica?.dirty || registerFormControl.personaJuridica?.touched || submitted)">
                La Persona Jurídica es Requerida
            </mat-error>
          </div>
        </div> 
      </div>
      <div class="row">
        <div class="col-md-6">
            <label class="col-form-label font-bold">Clase Documento</label>
            <div>
            <comboTools [list]=clasesDocList
                        selected='claseDocumento'
                        [formParent]="form"
                        [isEditing]=disabledEditing
                        filter="descripcion"
                        ph='Clase de Documento'></comboTools>
            <div *ngIf="registerFormControl.claseDocumento.invalid && (registerFormControl.claseDocumento?.dirty || registerFormControl.claseDocumento?.touched || submitted)" class="text-danger">
                La Clase Documento es Requerida
            </div>
            </div>
        </div>
        <div class="col-md-6">
            <label class=" col-form-label font-bold">Nro. Documento</label>
            <input formControlName="docNro" name ="selectedDocNro" type="text" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.docNro.errors && (registerFormControl.docNro?.dirty || registerFormControl.docNro?.touched || submitted)}"/>
            <mat-error  class="text-danger"*ngIf="registerFormControl.docNro.errors?.required && (registerFormControl.docNro?.dirty || registerFormControl.docNro?.touched || submitted)">
                El Nro. Documento es Requerido
            </mat-error>
        </div>
      </div>
      <div class="row" *ngIf="tipoCarga != 2 && tipoCarga != 4">
        <div class="col-md-6">
          <div class="form-group">
            <label class=" col-form-label font-bold">Importe</label>
            <input formControlName="importe" name ="selectedImporte" type="number" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.importe.errors && (registerFormControl.importe?.dirty || registerFormControl.importe?.touched || submitted)}"/>
            <mat-error  class="text-danger"*ngIf="registerFormControl.importe.errors?.required && (registerFormControl.importe?.dirty || registerFormControl.importe?.touched || submitted)">
                El Importe es Requerido
            </mat-error>
          </div>
          <!-- <app-input-numeric [inputNumericFormControl]="form" [ValidarRequerido]="true" placeHolderValue="Importe" [actualizarFormato]="actualizarFormatoInputNumerico"></app-input-numeric> -->
        </div>
        <div class="col-md-6">
          <label class="col-form-label font-bold">Moneda</label>
          <div>
            <comboTools [list]=monedasList
                        selected='moneda'
                        [formParent]="form"
                        [isEditing]=disabledEditing
                        filter="descripcion"
                        ph='Moneda'></comboTools>
            <div *ngIf="registerFormControl.moneda.invalid && (
                 registerFormControl.moneda?.dirty || registerFormControl.moneda?.touched || submitted)" class="text-danger">
              Moneda es Requerido
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6" *ngIf="tipoCarga != 1 && tipoCarga != 4">
          <div class="form-group">
            <label class=" col-form-label font-bold">Cantidad</label>
            <input formControlName="cantidad" name ="selectedCantidad" type="number" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.cantidad.errors && (registerFormControl.cantidad?.dirty || registerFormControl.cantidad?.touched || submitted)}"/>
            <mat-error  class="text-danger"*ngIf="registerFormControl.cantidad.errors?.required && (registerFormControl.cantidad?.dirty || registerFormControl.cantidad?.touched || submitted)">
                La Cantidad es Requerida
            </mat-error>
          </div>
        </div>
        <div class="col-md-6">
          
        </div>
      </div>
    </form>
  </div>
  
  